import { Pipe, PipeTransform } from '@angular/core';
import { toFixed } from '../interface';

@Pipe({ name: 'fixed' })
export class HxFixedPipe implements PipeTransform {

  transform(value: number, fraction?: number): any {
    return toFixed(value, fraction);
  }
}
